import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
    GET_AREA,
    GET_DT_BALANCE_ZONE,
    GET_ZONE,
    SAVE_DT_BALANCE_ZONE
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function ManageZone(props) {
    const dispatch = useDispatch();

    const [showManageZone, setShowManageZone] = useState(false);

    const [zoneManageList, setZoneManageList] = useState([]);
    const [customerTypeOption, setCustomerTypeOption] = useState([])
    const [zoneOption, setZoneOption] = useState([])
    const [areaOption, setAreaOption] = useState([])


    const rowStyleFontWhite = (row, rowIndex) => {
        const style = {};
        // style.fontWeight = 'bold';
        style.color = "white";

        return style;
    };


    const getBalanceZone = () => post(GET_DT_BALANCE_ZONE, {});
    const getZone = () => post(GET_ZONE, {});
    const getArea = () => post(GET_AREA, {});
    const handleAddZone = () => {
        setZoneManageList(prevent => [
            ...prevent,
            {
                ROW: zoneManageList.length + 1,
                PID: "",
                BALANCEZONE_ORDER: zoneManageList.length + 1,
                ZONE_PID: "",
                BALANCEZONE_ALIAS: "",
                BALANCEZONE_NAME: "",
                BALANCEZONE_AREA: "",
                BALANCEZONE_REPORT: "",
                BALANCEZONE_TYPE: 0,
                BALANCEZONE_DESC: "",
                BALANCEZONE_SHOW: true,
                PRIORITY_FLAG: 0,
                STATUS_FLAG: 0,
                SOURCE_PID: "",
                SOURCE_NAME: "",
                area: [],
                // color: colorOption[0],
                balacneZone:null,
                show: { label: "Show", value: 1 },
            },
        ]);
    };
    const handleSaveZone = async () => {
        function validateDuplicate() {
            let valueArr = zoneManageList.map(function (item) {
                return item.BALANCEZONE_ALIAS;
            });
            let isDuplicate = valueArr.some(function (item, idx) {
                return valueArr.indexOf(item) != idx;
            });
            return isDuplicate;
        }
        if (validateDuplicate()) {
            dispatch(messageAction.showMessage("Name is duplicate."));
            throw "exit";
        }
        dispatch(loadingAction.showLoading());
        try {
            if (
                !zoneManageList.some(
                    row => row.BALANCEZONE_ALIAS == "" || row.BALANCEZONE_ORDER == ""
                )
            ) {
                let data = [...zoneManageList];
                // console.log(data)
                data = data.map(row => ({
                    ...row,
                    BALANCEZONE_AREA: row.area.map(cus => cus.label).toString(),
                  }));
                let res = await post(SAVE_DT_BALANCE_ZONE, data);
                if (res.resultCode == 200) {
                    fetchData();
                    props.hide();
                    props.onChange();
                    dispatch(messageAction.showMessage("Save success."));
                }
            } else {
                dispatch(messageAction.showMessage("Plesae key in."));
            }
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };


    const fetchData = async () => {
        setZoneManageList([]);
        setZoneOption([])
        dispatch(loadingAction.showLoading());
        try {
            setShowManageZone(true);
            let [balanceZoneList, zoneList,areaList] = await Promise.all([getBalanceZone(), getZone(),getArea()]);
            areaList = areaList.data.areaList.map((area)=>({label :area.ALIAS_NAME,value:area.ALIAS_NAME}));
            setZoneOption(zoneList.data.zoneList.map((zone)=>({label :zone.ALIAS_NAME,value:zone.PID})))
            setAreaOption(areaList)
            // console.log(zoneList)
            setZoneManageList(
                balanceZoneList.data.dtBalanceList.map((obj, index) => ({
                    ...obj,
                    ROW: index + 1,
                    balanceZone: {label:obj.BALANCEZONE_NAME,value:obj.ZONE_PID},
                    area: obj.BALANCEZONE_AREA
                    ? areaList.filter(
                      opt => obj.BALANCEZONE_AREA.split(",").indexOf(opt.label) >= 0
                    )
                    : [],
                    // color: colorOption[obj.BALANCEZONE_TYPE],
                    // type: obj.BALANCEZONE_TYPE == 1 ? { label: "Non-Fuel", value: 1 } : { label: "Fuel", value: 0 },
                    show: obj.BALANCEZONE_SHOW == 1 ? { label: "Show", value: 1 } : { label: "Hide", value: 0 },
                }))
            );
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }

        dispatch(loadingAction.hideLoading());
    };

    useEffect(() => {
        if (props.show == true) {
            fetchData()
        }
    }, [props.show]);
    const PickColor = (cellContent, row) => {
        return (
            <SelectColor
                value={cellContent}
                onChange={selected => {
                    setZoneManageList(prev => {
                        return prev.map(obj => {
                            if (row.ROW == obj.ROW) {
                                return {
                                    ...obj,
                                    color: selected,
                                    BALANCEZONE_TYPE: selected.value
                                };
                            }
                            return { ...obj };
                        });
                    });
                }}
            />
        );
    };
    const columnOption = {
        menu: (provided, state) => ({
          ...provided,
          width: 270,
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor: isFocused ? "#2E3446" : undefined,
          };
        },
        multiValue: (styles, { data }) => {
          return {
            ...styles,
            backgroundColor: "#2A3042",
          };
        },
        multiValueLabel: (styles, { data }) => ({
          ...styles,
          color: "#FFFFFF",
        }),
        multiValueRemove: (styles, { data }) => ({
          ...styles,
          color: "#BFC8E2",
          ":hover": {
            backgroundColor: "#2A3042",
            color: "white",
          },
        }),
      };
    const SelectArea = (cellContent, row) => {
        return (
          <div>
            <Select
              value={cellContent}
              isClearable={true}
              isMulti
              onChange={selected => {
                setZoneManageList(prev => {
                  return prev.map(obj => {
                    if (row.ROW == obj.ROW) {
                        // console.log(selected)
                      return {
                        ...obj,
                        area: selected 
                      };
                    }
                    return { ...obj };
                  });
                });
              }}
              options={areaOption}
              classNamePrefix="select2-selection"
              styles={columnOption}
            />
          </div>
        );
      };
    
    const SelectZone = (cellContent, row) => {
        return (
            <>
       
            
            <Select
                value={cellContent}
                options={zoneOption}
                classNamePrefix="select2-selection"
                onChange={selected => {
                    setZoneManageList(prev => {
                        return prev.map(obj => {
                            if (row.ROW == obj.ROW) {
                                return {
                                    ...obj,
                                    balanceZone: selected,
                                    ZONE_PID:selected.value,
                                    BALANCEZONE_NAME: selected.label,
                                };
                            }
                            return { ...obj };
                        });
                    });
                }}

             />
            
            </>
           
        );
    };
    const SelectStyle ={
        option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
          ...provided,
          ...isFocused&&({backgroundColor:'#2E3460'})
        }),
      }
      const SelectType= (cellContent, row) => {
        return (
            <Select
                value={cellContent}
                options={[
                    { label: "Fuel", value: 0 },
                    { label: "Non-Fuel", value: 1 },
                ]}
                classNamePrefix="select2-selection"
                styles={SelectStyle}
                onChange={selected => {
                    setZoneManageList(prev => {
                        return prev.map(obj => {
                            if (row.ROW == obj.ROW) {
                                return {
                                    ...obj,
                                    type: selected,
                                    BALANCEZONE_TYPE: selected.value,
                                };
                            }
                            return { ...obj };
                        });
                    });
                }}
            />
        );
    };
    const SelectShow = (cellContent, row) => {
        return (
            <Select
                value={cellContent}
                options={[
                    { label: "Show", value: 1 },
                    { label: "Hide", value: 0 },
                ]}
                classNamePrefix="select2-selection"
                styles={SelectStyle}
                onChange={selected => {
                    setZoneManageList(prev => {
                        return prev.map(obj => {
                            if (row.ROW == obj.ROW) {
                                return {
                                    ...obj,
                                    show: selected,
                                    BALANCEZONE_SHOW: selected.value,
                                };
                            }
                            return { ...obj };
                        });
                    });
                }}
            />
        );
    };
    const SelectSource = (cellContent, row) => {
        return (
            <Select
                value={cellContent}
                options={[
                    { label: "Manual", value: 0 },
                    { label: "Scada", value: 1 },
                    { label: "Flow Selection", value: 2 },
                ]}
                classNamePrefix="select2-selection"
                onChange={selected => {
                    setZoneManageList(prev => {
                        return prev.map(obj => {
                            if (row.ROW == obj.ROW) {
                                return {
                                    ...obj,
                                    source: selected,
                                    STATUS_FLAG: selected.value,
                                };
                            }
                            return { ...obj };
                        });
                    });
                }}
            />
        );
    };


    // SOURCE_PID:"",
    // SOURCE_NAME:"",
    const zoneManage = [
        {
            dataField: "BALANCEZONE_ORDER",
            text: "Order",
            headerAlign: "center",
            sort: true,
            editable: true,
            align: "center",
            style: {
                width: "50px",
                cursor:"pointer",
            },
            type: "number",
        },
        {
            dataField: "BALANCEZONE_ALIAS",
            text: "Name",
            headerAlign: "center",
            sort: true,
            editable: true,
            align: "center",
            style: {
                width: "200px",
                cursor:"pointer",
            },
        },
        {
            dataField: "BALANCEZONE_REPORT",
            text: "Report",
            headerAlign: "center",
            sort: true,
            editable: true,
            align: "center",
            style: {
                width: "200px",
                cursor:"pointer",
            },
        },
        {
            dataField: "balanceZone",
            text: "Zone",
            headerAlign: "center",
            sort: true,
            editable:false,
            // editable: (content, row, rowIndex, zoneIndex) => row.PID == "",
            align: "center",
            style: {
                width: "120px",
            },
            sortFunc: (a, b, order, dataField) => {
                if (order === 'asc') {
                    return b.value - a.value;
                }
                return a.value - b.value; // desc
            },
            formatter: SelectZone
        },
        {
            dataField: "area",
            text: "Area",
            headerAlign: "center",
            sort: true,
            editable: false,
            align: "center",
            style: {
              width: "200px",
            },
            formatter: SelectArea,
          },
        // {
        //     dataField: "BALANCEZONE_DESC",
        //     text: "Description",
        //     headerAlign: "center",
        //     sort: true,
        //     editable: true,
        //     align: "center",
        //     style: {
        //         width: "200px",
        //     },
        // },
        // {
        //     dataField: "color",
        //     text: "Color",
        //     headerAlign: "center",
        //     sort: true,
        //     editable: false,
        //     align: "center",
        //     style: {
        //         width: "70px",
        //     },
        //     sortFunc: (a, b, order, dataField) => {
        //         if (order === 'asc') {
        //             return b.value - a.value;
        //         }
        //         return a.value - b.value; // desc
        //     },
        //     formatter: PickColor,
        // },

        // {
        //     dataField: "type",
        //     text: "Type",
        //     headerAlign: "center",
        //     sort: true,
        //     editable: false,
        //     align: "center",
        //     style: {
        //         width: "100px",
        //     },
        //     sortFunc: (a, b, order, dataField) => {
        //         if (order === 'asc') {
        //             return b.value - a.value;
        //         }
        //         return a.value - b.value; // desc
        //     },
        //     formatter: SelectType
        // },
        {
            dataField: "show",
            text: "Status",
            headerAlign: "center",
            sort: true,
            editable: false,
            align: "center",
            style: {
                width: "100px",
            },
            sortFunc: (a, b, order, dataField) => {
                if (order === 'asc') {
                    return b.value - a.value;
                }
                return a.value - b.value; // desc
            },
            formatter: SelectShow
        },
        // {
        //   dataField: "ACTION",
        //   isDummyField: true,
        //   text: "Action",
        //   headerAlign: "center",
        //   align: "center",
        //   style: {
        //     width: "150px",
        //   },
        //   formatter: deleteZoneButton,
        // },
    ];
    return (
        <>

            <Modal size="xl" isOpen={props.show} backdrop={"static"}>
                <div className="modal-header">
                    <h5 className="modal-title mt-0">Manage Zone Balancing & Shrinkage Gas</h5>
                    <button
                        type="button"
                        onClick={() => {
                            props.hide()
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>          </button>
                </div>
                <div className="modal-body">
                    <BootstrapTable
                        // id="zone-balancing-table"
                        // wrapperClasses="table-on-scroll"
                        keyField="ROW"
                        data={zoneManageList}
                        columns={zoneManage}
                        rowStyle={rowStyleFontWhite}
                        headerClasses="header-style"
                        defaultSorted={defaultSortZoneManage}
                        cellEdit={cellEditFactory({
                            mode: "click",
                            blurToSave: true,
                            afterSaveCell: (oldValue, newValue, row, zone) => {
                                // console.log(zoneDataList);
                            },
                        })}
                    />
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => handleAddZone()}
                        >
                            <i className="bx bx-plus"></i>&nbsp; Add
                        </button>

                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => handleSaveZone()}
                        >
                            <i className="bx bx-save"></i>&nbsp; Save
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => props.hide()}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
}
const defaultSortZoneManage = [
    {
        dataField: "BALANCEZONE_ORDER",
        order: "asc", // or desc
    },
];
export default ManageZone;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerZone



ManageZone.propTypes = {
    show: PropTypes.any,
    hide: PropTypes.any,
    onChange:PropTypes.any
};
